import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-tisco-information',
    templateUrl: './tisco-information.component.html',
    styleUrls: ['./tisco-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TiscoInformationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
